// @flow

import React, { type Node } from 'react';
import { Description, DescriptionTextHighlight } from '../';
import { useIncomingPayment, getCountry, getCustomerEmail } from '@tectonics/prs/incoming-payment';

export function VoucherMailWarning(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);
  const customerEmail = getCustomerEmail(incomingPayment);

  switch (country) {
    case 'mx':
      return (
        <Description>
          Usa los siguientes datos para realizar el pago. Se deseas, puedes consultar una cópia que fue enviada para&nbsp;
          <DescriptionTextHighlight>{customerEmail}</DescriptionTextHighlight>.
        </Description>
      );
    case 'co':
      return (
        <Description>
          Una cópia ya fue enviada para <DescriptionTextHighlight>{customerEmail}</DescriptionTextHighlight>,
          sin embargo, ya puedes pagar tu compra con los seguientes datos:
        </Description>
      );
    default:
      throw new Error('Not implemented yet');
  }
}
